import React from "react"

export default function Icons(props) {
  const { name } = props
  switch (name) {
    case "sun":
    return (
      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
        <path d="M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"></path>
      </svg>
    )
    case "moon":
    return (
      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
        <path d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"></path>
      </svg>
    )
    case "logo":
      return (
        <svg
          viewBox="0 0 150 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="75"
            cy="75"
            r="73"
            fill="white"
            stroke="#000"
            strokeWidth="4"
          />
          <path
            d="M84.6641 84.7715L84.6055 78.5898C84.6055 76.0703 84.3906 74.3027 83.9609 73.2871C83.5312 72.2715 82.9844 71.5098 82.3203 71.002C81.6562 70.4746 80.7578 70.2109 79.625 70.2109C78.5117 70.2109 76.1387 71.0898 72.5059 72.8477C72.0176 73.1406 71.7637 73.4141 71.7441 73.668V89.4297C71.7441 91.4023 72.7988 92.5352 74.9082 92.8281C75.8262 92.9648 76.2852 93.1895 76.2852 93.502C76.2852 93.7949 76.1875 93.9609 75.9922 94H62.9258C62.7305 93.9609 62.6328 93.8242 62.6328 93.5898C62.6328 93.2188 63.0918 92.9648 64.0098 92.8281C66.1191 92.5352 67.1738 91.4023 67.1738 89.4297V74.8398C67.1738 71.7734 65.2793 70.2402 61.4902 70.2402C60.1035 70.2402 58.1797 71.0605 55.7188 72.7012C55.0938 73.1113 54.6348 73.4922 54.3418 73.8438V89.4297C54.3418 91.4023 55.3965 92.5352 57.5059 92.8281C58.4238 92.9648 58.8828 93.1895 58.8828 93.502C58.8828 93.7949 58.7852 93.9609 58.5898 94H45.5234C45.3281 93.9609 45.2305 93.8242 45.2305 93.5898C45.2305 93.2188 45.6895 92.9648 46.6074 92.8281C48.7168 92.5352 49.7715 91.4219 49.7715 89.4883V72.6133C49.7715 71.793 49.3223 71.2266 48.4238 70.9141C48.0332 70.7773 47.6133 70.6699 47.1641 70.5918C46.7148 70.4941 46.3535 70.4062 46.0801 70.3281C45.8262 70.25 45.6602 70.1816 45.582 70.123C45.5234 70.0449 45.4941 69.8984 45.4941 69.6836C45.4941 69.4492 45.6406 69.2539 45.9336 69.0977L53.4043 65.582C53.6387 65.4648 53.7852 65.4062 53.8438 65.4062C54.1758 65.4062 54.3418 65.6406 54.3418 66.1094V70.9727C54.3613 71.0898 54.4297 71.1484 54.5469 71.1484C54.6836 71.1484 55.0059 71.0117 55.5137 70.7383C56.041 70.4648 56.7246 70.084 57.5645 69.5957C58.4043 69.0879 59.5078 68.502 60.875 67.8379C62.2617 67.1738 63.7266 66.8418 65.2695 66.8418C67.75 66.8418 69.5273 67.9062 70.6016 70.0352C71.0117 70.8945 71.3828 71.2656 71.7148 71.1484C72.0469 71.0117 72.5645 70.7676 73.2676 70.416C74.9277 69.5957 76.6074 68.7949 78.3066 68.0137C80.0059 67.2324 81.4121 66.8418 82.5254 66.8418C87.0371 66.8418 89.293 70.9531 89.293 79.1758L89.0293 87.7305V89.4297C89.0293 90.9531 89.791 91.9492 91.3145 92.418C91.959 92.6328 92.5742 92.7891 93.1602 92.8867C93.7656 92.9648 94.1562 93.043 94.332 93.1211C94.5273 93.1992 94.625 93.3555 94.625 93.5898C94.625 93.8242 94.5273 93.9609 94.332 94H80.2109C80.0156 93.9609 79.918 93.8242 79.918 93.5898C79.918 93.2188 80.377 92.9648 81.2949 92.8281C83.3848 92.5352 84.4297 91.3242 84.4297 89.1953C84.5859 88.2188 84.6641 86.7441 84.6641 84.7715Z"
            fill="#000"
          />
          <path
            d="M89.752 79.9668C89.5176 79.9668 89.4004 80.4453 89.4004 81.4023V89.5469C89.4004 91.4609 90.4551 92.5742 92.5645 92.8867C93.4824 93.0039 93.9414 93.2188 93.9414 93.5312C93.9414 93.8438 93.8438 94 93.6484 94H80.582C80.3867 93.9609 80.2891 93.8242 80.2891 93.5898C80.2891 93.2383 80.748 93.0039 81.666 92.8867C83.7754 92.5742 84.8301 91.4609 84.8301 89.5469V53.0137C84.8301 52.1934 84.3809 51.627 83.4824 51.3145C83.0918 51.1777 82.6719 51.0703 82.2227 50.9922C81.7734 50.8945 81.4121 50.8066 81.1387 50.7285C80.8848 50.6504 80.7188 50.582 80.6406 50.5234C80.582 50.4453 80.5527 50.2988 80.5527 50.084C80.5527 49.8496 80.6992 49.6543 80.9922 49.498L88.4629 45.9824C88.6973 45.8652 88.8438 45.8066 88.9023 45.8066C89.2344 45.8066 89.4004 46.041 89.4004 46.5098V75.748C89.5566 76.3145 89.7617 76.6465 90.0156 76.7441C90.2695 76.8418 90.543 76.8906 90.8359 76.8906C91.4023 76.8906 92.3301 76.4512 93.6191 75.5723C94.9277 74.6738 96.1094 73.6777 97.1641 72.584C98.2188 71.4707 98.7461 70.709 98.7461 70.2988C98.7461 69.8691 98.5605 69.6055 98.1895 69.5078C97.8184 69.3906 97.3984 69.3125 96.9297 69.2734C96.4805 69.2148 96.0703 69.1367 95.6992 69.0391C95.3281 68.9219 95.1426 68.6582 95.1426 68.248C95.1426 67.8379 95.543 67.6328 96.3438 67.6328H107.506C108.189 67.6328 108.531 67.8574 108.531 68.3066C108.531 68.541 108.307 68.7266 107.857 68.8633C107.408 69 106.539 69.2148 105.25 69.5078C103.961 69.7812 102.936 70.2207 102.174 70.8262L93.7656 77.3887C93.7656 77.6426 93.9512 77.9551 94.3223 78.3262L106.363 91.0117C107.145 91.8125 107.945 92.3398 108.766 92.5938C109.586 92.8281 110.133 92.9844 110.406 93.0625C110.68 93.1406 110.816 93.2773 110.816 93.4727C110.816 93.8242 110.66 94 110.348 94H97.4863C97.291 94 97.1934 93.8828 97.1934 93.6484C97.1934 93.2969 97.4375 93.0723 97.9258 92.9746C99.3906 92.7012 100.123 92.2031 100.123 91.4805C100.123 91.2656 99.9766 90.9824 99.6836 90.6309C99.3906 90.2793 99.1172 89.9375 98.8633 89.6055L89.8105 80.0254C89.8105 80.0059 89.8008 79.9863 89.7812 79.9668H89.752Z"
            fill="#000"
          />
        </svg>
      )
    case "menu-burger":
      return (
        <svg viewBox="0 0 40 15" fill="none">
          <path
            d="M38.75 0H1.24997C0.559941 0 0 0.560046 0 1.24997C0 1.9399 0.560045 2.49995 1.24997 2.49995H38.75C39.4401 2.49995 40 1.9399 40 1.24997C40 0.560046 39.4401 0 38.75 0Z"
          />
          <path
            d="M38.75 12.5H1.24997C0.559941 12.5 0 13.0601 0 13.75C0 14.4401 0.560045 15 1.24997 15H38.75C39.4401 15 40 14.4399 40 13.75C40.0001 13.06 39.4401 12.5 38.75 12.5Z"
          />
        </svg>
      )
    case "arrow-up":
      return (
        <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
          <path d="m32 56c1.104 0 2-.896 2-2v-39.899l14.552 15.278c.393.413.92.621 1.448.621.495 0 .992-.183 1.379-.552.8-.762.831-2.028.069-2.828l-16.619-17.448c-.756-.755-1.76-1.172-2.829-1.172s-2.073.417-2.862 1.207l-16.586 17.414c-.762.8-.731 2.066.069 2.828s2.067.731 2.828-.069l14.551-15.342v39.962c0 1.104.896 2 2 2z" />
        </svg>
      )
    case "arrow-right":
      return (
        <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
          <path d="m37.379 12.552c-.799-.761-2.066-.731-2.827.069-.762.8-.73 2.066.069 2.828l15.342 14.551h-39.963c-1.104 0-2 .896-2 2s.896 2 2 2h39.899l-15.278 14.552c-.8.762-.831 2.028-.069 2.828.393.412.92.62 1.448.62.496 0 .992-.183 1.379-.552l17.449-16.62c.756-.755 1.172-1.759 1.172-2.828s-.416-2.073-1.207-2.862z" />
        </svg>
      )
    case "cancel":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.001 512.001">
          <path
            d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
            L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
            c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
            l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
            L284.286,256.002z"
          />
        </svg>
      )
    case "facebook":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            style={{ fill: "#2196F3" }}
            d="M320,85.333h64c5.891,0,10.667-4.776,10.667-10.667v-64C394.667,4.776,389.891,0,384,0h-64
            c-64.772,0.071-117.263,52.561-117.333,117.333V192H128c-5.891,0-10.667,4.776-10.667,10.667v64c0,5.891,4.776,10.667,10.667,10.667
            h74.667v224c0,5.891,4.776,10.667,10.667,10.667h64c5.891,0,10.667-4.776,10.667-10.667v-224h74.667
            c4.589-0.003,8.662-2.942,10.112-7.296l21.333-64c1.862-5.589-1.16-11.629-6.749-13.491c-1.084-0.361-2.22-0.546-3.363-0.547h-96
            v-74.667C288,99.66,302.327,85.333,320,85.333z"
          />
        </svg>
      )
    case "instagram":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <linearGradient
            id="SVGID_1_"
            gradientUnits="userSpaceOnUse"
            x1="-46.0041"
            y1="634.1208"
            x2="-32.9334"
            y2="647.1917"
            gradientTransform="matrix(32 0 0 -32 1519 20757)"
          >
            <stop offset="0" style={{ stopColor: "#FFC107" }} />
            <stop offset="0.507" style={{ stopColor: "#F44336" }} />
            <stop offset="0.99" style={{ stopColor: "#9C27B0" }} />
          </linearGradient>
          <path
            style={{ fill: "url(#SVGID_1_)" }}
            d="M352,0H160C71.648,0,0,71.648,0,160v192c0,88.352,71.648,160,160,160h192
            c88.352,0,160-71.648,160-160V160C512,71.648,440.352,0,352,0z M464,352c0,61.76-50.24,112-112,112H160c-61.76,0-112-50.24-112-112
            V160C48,98.24,98.24,48,160,48h192c61.76,0,112,50.24,112,112V352z"
          />
          <linearGradient
            id="SVGID_2_"
            gradientUnits="userSpaceOnUse"
            x1="-42.2971"
            y1="637.8279"
            x2="-36.6404"
            y2="643.4846"
            gradientTransform="matrix(32 0 0 -32 1519 20757)"
          >
            <stop offset="0" style={{ stopColor: "#FFC107" }} />
            <stop offset="0.507" style={{ stopColor: "#F44336" }} />
            <stop offset="0.99" style={{ stopColor: "#9C27B0" }} />
          </linearGradient>
          <path
            style={{ fill: "url(#SVGID_2_)" }}
            d="M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128
            S326.688,128,256,128z M256,336c-44.096,0-80-35.904-80-80c0-44.128,35.904-80,80-80s80,35.872,80,80
            C336,300.096,300.096,336,256,336z"
          />
          <linearGradient
            id="SVGID_3_"
            gradientUnits="userSpaceOnUse"
            x1="-35.5456"
            y1="644.5793"
            x2="-34.7919"
            y2="645.3331"
            gradientTransform="matrix(32 0 0 -32 1519 20757)"
          >
            <stop offset="0" style={{ stopColor: "#FFC107" }} />
            <stop offset="0.507" style={{ stopColor: "#F44336" }} />
            <stop offset="0.99" style={{ stopColor: "#9C27B0" }} />
          </linearGradient>
          <circle
            style={{ fill: "url(#SVGID_3_)" }}
            cx="393.6"
            cy="118.4"
            r="17.056"
          />
        </svg>
      )
    case "whatsapp":
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            fill="#30cf4e"
            d="M12.036 5.339c-3.635 0-6.591 2.956-6.593 6.589-.001 1.483.434 2.594 1.164 3.756l-.666 2.432 2.494-.654c1.117.663 2.184 1.061 3.595 1.061 3.632 0 6.591-2.956 6.592-6.59.003-3.641-2.942-6.593-6.586-6.594zm3.876 9.423c-.165.463-.957.885-1.337.942-.341.051-.773.072-1.248-.078-.288-.091-.657-.213-1.129-.417-1.987-.858-3.285-2.859-3.384-2.991-.099-.132-.809-1.074-.809-2.049 0-.975.512-1.454.693-1.653.182-.2.396-.25.528-.25l.38.007c.122.006.285-.046.446.34.165.397.561 1.372.611 1.471.049.099.083.215.016.347-.066.132-.099.215-.198.33l-.297.347c-.099.099-.202.206-.087.404.116.198.513.847 1.102 1.372.757.675 1.395.884 1.593.983.198.099.314.083.429-.05.116-.132.495-.578.627-.777s.264-.165.446-.099 1.156.545 1.354.645c.198.099.33.149.38.231.049.085.049.482-.116.945zm3.088-14.762h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-6.967 19.862c-1.327 0-2.634-.333-3.792-.965l-4.203 1.103 1.125-4.108c-.694-1.202-1.059-2.566-1.058-3.964.002-4.372 3.558-7.928 7.928-7.928 2.121.001 4.112.827 5.609 2.325s2.321 3.491 2.32 5.609c-.002 4.372-3.559 7.928-7.929 7.928z"
          />
        </svg>
      )
    case "linkedin":
      return (
        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <path
            fill="#0077b5"
            d="m475.074219 0h-438.148438c-20.394531 0-36.925781 16.53125-36.925781 36.925781v438.148438c0 20.394531 16.53125 36.925781 36.925781 36.925781h438.148438c20.394531 0 36.925781-16.53125 36.925781-36.925781v-438.148438c0-20.394531-16.53125-36.925781-36.925781-36.925781zm-293.464844 387h-62.347656v-187.574219h62.347656zm-31.171875-213.1875h-.40625c-20.921875 0-34.453125-14.402344-34.453125-32.402344 0-18.40625 13.945313-32.410156 35.273437-32.410156 21.328126 0 34.453126 14.003906 34.859376 32.410156 0 18-13.53125 32.402344-35.273438 32.402344zm255.984375 213.1875h-62.339844v-100.347656c0-25.21875-9.027343-42.417969-31.585937-42.417969-17.222656 0-27.480469 11.601563-31.988282 22.800781-1.648437 4.007813-2.050781 9.609375-2.050781 15.214844v104.75h-62.34375s.816407-169.976562 0-187.574219h62.34375v26.558594c8.285157-12.78125 23.109375-30.960937 56.1875-30.960937 41.019531 0 71.777344 26.808593 71.777344 84.421874zm0 0"
          />
        </svg>
      )
    case "github":
      return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="m12 .5c-6.63 0-12 5.28-12 11.792 0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56 4.801-1.548 8.236-5.97 8.236-11.173 0-6.512-5.373-11.792-12-11.792z" />
        </svg>
      )
    case "icon-code":
      return (
        <svg
          width="62px"
          height="49px"
          viewBox="0 0 62 49"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>icon-for-dev-guide</title>
          <g
            id="Pages"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Solution-For-Icons"
              transform="translate(-95.000000, -152.000000)"
            >
              <g
                id="icon-for-dev-guide"
                transform="translate(95.000000, 152.000000)"
              >
                <circle
                  className="shape"
                  id="Oval"
                  fill="#FEE9E9"
                  cx="17"
                  cy="33"
                  r="16"
                ></circle>
                <g id="Group-3" fill="#1B243F" className="stroke">
                  <g
                    id="Group-2"
                    transform="translate(19.281362, 19.957761) rotate(-135.000000) translate(-19.281362, -19.957761) translate(5.781362, 6.457761)"
                  >
                    <rect
                      id="Rectangle"
                      x="0.790405877"
                      y="0.978286438"
                      width="2"
                      height="26"
                      rx="1"
                    ></rect>
                    <path
                      d="M13.8112212,12.9991017 C14.3635059,12.9991017 14.8112212,13.446817 14.8112212,13.9991017 L14.8112212,37.9991017 C14.8112212,38.5513865 14.3635059,38.9991017 13.8112212,38.9991017 C13.2589364,38.9991017 12.8112212,38.5513865 12.8112212,37.9991017 L12.8112212,13.9991017 C12.8112212,13.446817 13.2589364,12.9991017 13.8112212,12.9991017 Z"
                      id="Rectangle"
                      transform="translate(13.811221, 25.999102) rotate(-270.000000) translate(-13.811221, -25.999102) "
                    ></path>
                  </g>
                  <rect
                    id="Rectangle"
                    x="36"
                    y="33"
                    width="26"
                    height="2"
                    rx="1"
                  ></rect>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case "icon-flash":
      return (
        <svg
          width="58px"
          height="53px"
          viewBox="0 0 58 53"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            id="Pages"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="Solution-For-Icons"
              transform="translate(-994.000000, -418.000000)"
            >
              <g
                id="icon-for-age-less-main"
                transform="translate(994.000000, 419.000000)"
              >
                <path
                  className="shape"
                  d="M22.972136,23.9442719 L33.381966,44.763932 C34.6169123,47.2338245 33.6157905,50.2371897 31.145898,51.472136 C30.4516209,51.8192745 29.6860555,52 28.9098301,52 L8.09016994,52 C5.32874619,52 3.09016994,49.7614237 3.09016994,47 C3.09016994,46.2237745 3.2708954,45.4582092 3.61803399,44.763932 L14.027864,23.9442719 C15.2628103,21.4743794 18.2661755,20.4732577 20.736068,21.7082039 C21.703705,22.1920224 22.4883174,22.9766349 22.972136,23.9442719 Z"
                  id="Triangle"
                  fill="#FFF3D7"
                ></path>
                <polygon
                  className="stroke"
                  id="Shape"
                  stroke="#1B243F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="40 0 19 25.2 37.9 25.2 35.8 42 56.8 16.8 37.9 16.8"
                ></polygon>
              </g>
            </g>
          </g>
        </svg>
      )
    case "icon-users":
      return (
        <svg
          width="62px"
          height="50px"
          viewBox="0 0 62 50"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Hp-v3" transform="translate(-550.000000, -1293.000000)">
              <g
                id="collaboration"
                transform="translate(550.000000, 1294.000000)"
              >
                <rect
                  className="shape"
                  id="Rectangle"
                  fill="#DBF5FE"
                  x="0"
                  y="19"
                  width="30"
                  height="30"
                  rx="5"
                ></rect>
                <g
                  className="stroke"
                  id="user-check"
                  transform="translate(10.000000, 0.000000)"
                  stroke="#1B243F"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path
                    d="M51,38 L51,33.6666667 C51,28.8801988 47.1794965,25 42.4666667,25 L27.5333333,25 C22.8205035,25 19,28.8801988 19,33.6666667 L19,38"
                    id="Shape"
                  ></path>
                  <circle id="Oval" cx="35.5" cy="8.5" r="8.5"></circle>
                  <path
                    d="M23,26 L8.36363636,26 C3.74452755,26 0,28.3878147 0,31.3333333 L0,34"
                    id="Path"
                  ></path>
                  <circle id="Oval" cx="13.5" cy="12.5" r="6.5"></circle>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case "icon-heart":
      return (
        <svg
          width="54px"
          height="49px"
          viewBox="0 0 54 49"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-402.000000, -2566.000000)">
              <g id="Group-3" transform="translate(355.000000, 2494.000000)">
                <g id="nonprofits" transform="translate(47.000000, 74.000000)">
                  <circle
                    className="shape"
                    id="Oval"
                    fill="#FEE9E9"
                    cx="15"
                    cy="32"
                    r="15"
                  ></circle>
                  <path
                    className="stroke"
                    d="M40.2672882,-1 C43.7941644,-1 47.0364247,0.401110844 49.400015,2.93951215 C51.7134503,5.42431114 53,8.81563683 53,12.4981134 C53,16.2317922 51.6234632,19.6619304 48.601541,23.2723036 C46.0285311,26.3467137 42.3352174,29.4718547 38.0532578,33.0849563 C36.5834978,34.3254317 34.9609065,35.6948662 33.2781292,37.1520294 C32.648439,37.6980492 31.8390504,38 31,38 C30.1605968,38 29.3516934,37.6981958 28.7218272,37.1519123 C27.0258794,35.6836606 25.3925086,34.3052305 23.9513596,33.0889936 C19.6653992,29.4724208 15.9719096,26.3468535 13.3987874,23.2726304 C10.3768376,19.6618869 9,16.2317534 9,12.4984307 C9,8.81564195 10.2865427,5.42434511 12.5997004,2.93947361 C14.9632477,0.401118594 18.205843,-1 21.7327118,-1 C24.3801035,-1 26.8053547,-0.172866268 28.9396983,1.46165552 C29.6758033,2.0253043 30.3644769,2.67608478 31.0001135,3.40909186 C31.6356348,2.67594903 32.3240668,2.02534148 33.0599933,1.46164631 C35.1947103,-0.172893435 37.6199341,-1 40.2672882,-1 Z"
                    id="Path"
                    stroke="#1B243F"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case "icon-eye":
      return (
        <svg
          width="50px"
          height="50px"
          viewBox="0 0 27 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-111.000000, -139.000000)">
              <g
                id="nav-icon-visual-editor"
                transform="translate(111.000000, 139.000000)"
              >
                <path
                  d="M8.83231467,8.18814782 L12.7742835,17.1983623 C13.2170158,18.2103218 12.755566,19.3895824 11.7436065,19.8323147 C11.4908216,19.9429081 11.2178875,20 10.9419689,20 L3.05803115,20 C1.95346165,20 1.05803115,19.1045695 1.05803115,18 C1.05803115,17.7240813 1.11512308,17.4511472 1.22571648,17.1983623 L5.16768533,8.18814782 C5.61041759,7.17618837 6.78967822,6.71473856 7.80163767,7.15747081 C8.26261494,7.35914837 8.63063711,7.72717054 8.83231467,8.18814782 Z"
                  id="Triangle"
                  fill="#EEE9FE"
                  className="shape"
                ></path>
                <g
                  className="stroke"
                  id="eye"
                  transform="translate(4.000000, 0.000000)"
                  stroke="#324051"
                  strokeWidth="1"
                >
                  <path
                    d="M11.5,1 C17.3220178,1 20.9458477,6.81922925 21.8684066,8.49490447 C21.2926612,9.51735723 19.6687466,12.1227625 17.1396157,13.9921202 C15.5983542,15.1313134 13.7100834,16 11.5,16 C5.67798223,16 2.05415227,10.1807708 1.13159342,8.50509553 C1.70733881,7.48264277 3.33125339,4.87723749 5.86038433,3.00787985 C7.40164575,1.86868662 9.28991663,1 11.5,1 Z"
                    id="Shape"
                  ></path>
                  <circle
                    fill="transparent"
                    id="Oval"
                    cx="11.5"
                    cy="8.5"
                    r="2.5"
                  ></circle>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    case "icon-stack":
      return (
        <svg
          width="62px"
          height="50px"
          viewBox="0 0 29 23"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-111.000000, -181.000000)">
              <g transform="translate(111.000000, 181.000000)">
                <g
                  className="shape"
                  transform="translate(0.000000, 8.681818)"
                  fill="#EBFEDB"
                >
                  <rect
                    x="0"
                    y="0.318181818"
                    width="13"
                    height="13"
                    rx="2"
                  ></rect>
                </g>
                <g
                  className="stroke"
                  transform="translate(3.545455, 0.000000)"
                  stroke="#324051"
                  strokeWidth="1"
                >
                  <path d="M12.0606262,1.25679014 C12.312175,1.14898352 12.596916,1.14898352 12.8484648,1.25679014 L12.8484648,1.25679014 L19.4379493,4.08085497 C19.6739642,4.1820042 19.8620258,4.37006582 19.9631751,4.6060807 C20.0719529,4.85989559 20.0675539,5.13377277 19.9725067,5.37139068 C19.8774596,5.60900858 19.6917642,5.81036722 19.4379493,5.91914503 L19.4379493,5.91914503 L12.8484648,8.74320986 C12.596916,8.85101648 12.312175,8.85101648 12.0606262,8.74320986 L12.0606262,8.74320986 L5.47114156,5.91914503 C5.23512668,5.8179958 5.04706506,5.62993418 4.94591583,5.3939193 C4.83713802,5.14010441 4.841537,4.86622723 4.93658417,4.62860932 C5.03163133,4.39099142 5.21732667,4.18963278 5.47114156,4.08085497 L5.47114156,4.08085497 Z"></path>
                  <polyline
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="4.45454545 14 12.4545455 17 20.4545455 14"
                  ></polyline>
                  <polyline
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    points="4.45454545 10 12.4545455 13 20.4545455 10"
                  ></polyline>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )
    default:
      return <i>!</i>
  }
}
